// Line chart of a user's daily points on their profile
// (itword/templates/itword/components/_profile_chart.html). Days without a
// completed game are null and show as gaps in the line.

import { setupCharts } from './charts.js'

const buildProfileChart = ({ Chart, canvas, data, colour, animation }) =>
    new Chart(canvas, {
        type: 'line',
        data: {
            labels: data.map((day) => day.label),
            datasets: [
                {
                    label: 'Points',
                    data: data.map((day) => day.score),
                    borderColor: colour('primary'),
                    pointBackgroundColor: colour('primary'),
                    pointBorderColor: colour('background'),
                    borderWidth: 2,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    pointBorderWidth: 2,
                },
            ],
        },
        options: {
            maintainAspectRatio: false,
            animation,
            interaction: { mode: 'index', intersect: false },
            scales: {
                x: {
                    ticks: {
                        color: colour('text'),
                        maxRotation: 0,
                        autoSkipPadding: 16,
                    },
                    grid: { display: false },
                    border: { display: false },
                },
                y: {
                    beginAtZero: false,
                    ticks: { color: colour('text'), precision: 0 },
                    grid: { color: colour('grid') },
                    border: { display: false },
                },
            },
            plugins: {
                tooltip: {
                    backgroundColor: colour('text'),
                    titleColor: colour('background'),
                    bodyColor: colour('background'),
                    displayColors: false,
                    callbacks: {
                        label: (context) => `${context.parsed.y} points`,
                    },
                },
            },
        },
    })

setupCharts('[data-profile-chart]', buildProfileChart)
